import { Model, HasOne, Attr } from 'spraypaint';
import ApplicationRecord from '../../ApplicationRecord';
import type AuditsExport from '../AuditsExport';

type EmployeeSelectionEnum = 'with_contract' | 'not_archived';

@Model()
class AuditsExportsActiveEmployeesExport extends ApplicationRecord {
  static jsonapiType = 'audits-exports-active_employees_exports';

  // Attributes
  @Attr() date!: string;
  @Attr() employeeSelection!: EmployeeSelectionEnum;

  // Extra-attributes

  // Relationships
  @HasOne('audits-exports') export!: AuditsExport;
}

export default AuditsExportsActiveEmployeesExport;
